import React, { useState } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { LocationResponseDTO } from 'submodules/nerit-aquatec-sdk/services/location/dtos/responses/LocationResponseDTO'
import { ModalLocationCampaignsCP } from 'modules/locations/components/modal-location-campaigns/ModalLocationCampaignsCP'

interface ICPProps {
    location: LocationResponseDTO
}

export function ButtonViewCampaignsCP(props: ICPProps): JSX.Element {

    const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

    return (
        <>
            <ButtonCP
                icon={'eye'}
                size={'small'}
                onClick={() => setIsModalVisible(true)}
            >
                Ver Campanhas
            </ButtonCP>

            <ModalLocationCampaignsCP
                location={props.location}
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
            />
        </>
    )
}
